export const language = {
  en: {
    'view': 'view',
    'determine': 'determine',
    'Serial Number': 'Serial Number',
    'resetting': 'resetting',
    'query': 'query',
    'operate': 'operate',
    'time': 'time',
    'Select Start Time': 'Select Start Time',
    'Select End Time': 'Select End Time',
    'In total': 'In total',
    'data': 'data',
    'whole': 'whole',
    'CP group': 'CP group',
    'Non CP group': 'Non CP group',
    'group': 'group',
    'company': 'company',
    'store': 'store',
    'warehouse': 'warehouse',

    'Confirm': 'Confirm',
    'Edit': 'Edit',
    'Save': 'Save',
    'Cancel': 'Cancel',
    'Please Entry': 'Please Entry',
    'Please select': 'Please select',
    'Supplier Management': 'Supplier Management',
    'Awaiting Cooperation': 'Awaiting Cooperation',
    'Supplier Name': 'Supplier Name',
    'Category': 'Category',
    'Settlement Time': 'Settlement Time',
    'Company Attributes': 'Company Attributes',
    'Company Type': 'Company Type',
    'Negotiating': 'Negotiating',
    'Settlement': 'Settlement',
    'Negotiation': 'Negotiation',
    'Start Time of Negotiation': 'Start Time of Negotiation',
    'In Cooperation': 'In Cooperation',
    'Cooperation': 'Cooperation',
    'Start Time of Cooperation': 'Start Time of Cooperation',
    'In Retreat': 'In Retreat',
    'Retreat Initiation': 'Retreat Initiation',
    'Retreat Initiation Time': 'Retreat Initiation Time',
    'End the Cooperation': 'End the Cooperation',
    'Termination time of cooperation': 'Termination time of cooperation',
    'Confirm cooperation time': 'Confirm cooperation time',
    'Operator': 'Operator',
    'Unified Social Credit Code': 'Unified Tax ID',
    'Discussion on Cooperation': 'Discussion on Cooperation',
    'Confirm Cooperation': 'Confirm Cooperation',
    'Termination of Negotiation': 'Termination of Negotiation',
    'Renew the Contract': 'Renew the Contract',
    'Initiate Retreat': 'Initiate Retreat',
    'Cancel clearance': 'Cancel clearance',
    'Initiate liquidation': 'Initiate liquidation',
    'Termination of Cooperation': 'Termination of Cooperation',
    'Renegotiate': 'Renegotiate',
    'Company Basic Information': 'Company Basic Information',
    'Company Name': 'Company Name',
    'Company Name English': 'Company Name English',
    'Company Country': 'Company Country',
    'China': 'China',
    'Thailand': 'Thailand',
    'Australia': 'Australia',
    'United States': 'United States',
    'United Kingdom': 'United Kingdom',
    'France': 'France',
    'Company Address': 'Company Address',
    'Province': 'Province',
    'City': 'City',
    'District': 'District',
    'Bank Account': 'Bank Account',
    'Bank Name': 'Bank Name',
    'Landline Number': 'Landline Number',
    'Tel Number': 'Tel Number',
    'Email': 'Email',
    'Whether Production Base': 'Whether Production Base',
    'Yes': 'Yes',
    'No': 'No',
    'Mechanical and electrical equipment, Pet Food, Rice&Flour, Eggs, Condiments, Convenience Food, Non-Food, Chicken, Beverages, Packaging Materials, Beef, Other Livestock and Poultry, Dairy, Edible Oil, Vegetables, Aquatic Products, Fruits, Snacks, Duck, Lamb, Pork, All': 'Mechanical and electrical equipment, Pet Food, Rice&Flour, Eggs, Condiments, Convenience Food, Non-Food, Chicken, Beverages, Packaging Materials, Beef, Other Livestock and Poultry, Dairy, Edible Oil, Vegetables, Aquatic Products, Fruits, Snacks, Duck, Lamb, Pork, All',
    'Company Address Management': 'Company Address Management',
    'Address information': 'Address information',
    'Contact Name ': 'Contact Name ',
    'Please Entry Contact Name ': 'Please Entry Contact Name ',
    'Contact Information': 'Contact Information',
    'Please Entry Contact Information': 'Please Entry Contact Information',
    'Country': 'Country',
    'Detail Address': 'Detail Address',
    'Please Entry Detail Address': 'Please Entry Detail Address',
    'Address': 'Address',
    'Post Code': 'Post Code',
    'Please Entry Post Code': 'Please Entry Post Code',
    'Receiving region': 'Receiving region',
    'Remarks': 'Remarks',
    'Qualification information': 'Qualification information',
    'Company License Management': 'Company License Management',
    'Please upload Company License Management': 'Please upload Company License Management',
    'Please upload Business License': 'Please upload Business License',
    'Please upload Legal Person Certificate': 'Please upload Legal Person Certificate',
    'Please upload Company Certificate': 'Please upload Company Certificate',
    'Business License': 'Business License',
    'Legal Person Certificate': 'Legal Person Certificate',
    'Company Certificate': 'Company Certificate',
    'Qualification materials': 'Qualification materials',
    'Upload Files': 'Upload Files',
    'Upload': 'Upload',
    'Support Extension': 'Support Extension',
    'Certification': 'Certification',
    'Life Cycle Management': 'Life Cycle Management',
    'Cooperative category': 'Cooperative category',
    'Contract Document': 'Contract Document',
    'You are already a supplier': 'You are already a supplier',
    'Cannot be greater than 50M': 'Cannot be greater than 50M',
    'Admission application approval is pending, please be patient~': 'Admission application approval is pending, please be patient~',
    'The application for entry has been rejected for the following reasons:': 'The application for entry has been rejected for the following reasons:',
    'Back': 'Back',
    'Continue to apply': 'Continue to apply',
    'Apply': 'Apply',
    'reapply': 'reapply'
  },
  zh: {
    'view': '查看',
    'determine': '确定',
    'Serial Number': '序号',
    'resetting': '重置',
    'query': '查询',
    'operate': '操作',
    'time': '时间',
    'Select Start Time': '选择开始时间',
    'Select End Time': '选择结束时间',
    'In total': '总共',
    'data': '数据',
    'whole': '全部',
    'CP group': '正大',
    'Non CP group': '非正大',
    'group': '集团',
    'company': '公司',
    'store': '门店',
    'warehouse': '大仓',


    'Confirm': '确认',
    'Edit': '编辑',
    'Save': '保存',
    'Cancel': '取消',
    'Please Entry': '请输入',
    'Please select': '请选择',
    'Supplier Management': '供应商管理',
    'Awaiting Cooperation': '待合作',
    'Supplier Name': '供应商名称',
    'Category': '经营品类',
    'Settlement Time': '入驻时间',
    'Company Attributes': '公司属性',
    'Company Type': '公司类型',
    'Negotiating': '洽谈中',
    'Settlement': '入驻',
    'Negotiation': '洽谈开始',
    'Start Time of Negotiation': '洽谈开始时间',
    'In Cooperation': '合作中',
    'Cooperation': '合作开始',
    'Start Time of Cooperation': '合作开始时间',
    'In Retreat': '清退中',
    'Retreat Initiation': '清退发起',
    'Retreat Initiation Time': '发起清退时间',
    'End the Cooperation': '合作终止',
    'Termination time of cooperation': '合作终止时间',
    'Confirm cooperation time': '确认合作时间',
    'Operator': '操作人',
    'Unified Social Credit Code': '统一社会信用代码',
    'Discussion on Cooperation': '合作洽谈',
    'Confirm Cooperation': '确认合作',
    'Termination of Negotiation': '终止洽谈',
    'Renew the Contract': '续签合同',
    'Initiate Retreat': '发起清退',
    'Cancel clearance': '取消清退',
    'Initiate liquidation': '取消强推',
    'Termination of Cooperation': '终止合作',
    'Renegotiate': '重新洽谈',
    'Company Basic Information': '基本信息',
    'Company Name': '公司名称',
    'Company Name English': '公司名称(英文)',
    'Company Country': '公司所在国家',
    'China': '中国',
    'Thailand': '泰国',
    'Australia': '澳大利亚',
    'United States': '美国',
    'United Kingdom': '英国',
    'France': '法国',
    'Company Address': '公司地址',
    'Province': '省',
    'City': '市',
    'District': '区',
    'Bank Account': '银行账号',
    'Bank Name': '银行名称',
    'Landline Number': '座机号',
    'Tel Number': '手机号',
    'Email': '邮箱',
    'Whether Production Base': '是否基地',
    'Yes': '是',
    'No': '否',
    'Mechanical and electrical equipment, Pet Food, Rice&Flour, Eggs, Condiments, Convenience Food, Non-Food, Chicken, Beverages, Packaging Materials, Beef, Other Livestock and Poultry, Dairy, Edible Oil, Vegetables, Aquatic Products, Fruits, Snacks, Duck, Lamb, Pork, All': '机电设备、宠物食品、大米/面粉、蛋类、调味品、方便食品、非食品类、鸡肉、酒水饮料、可销售包材、牛肉、其他畜禽类、乳制品、食用油、蔬菜、水产、水果、休闲零食、鸭肉、羊肉、猪肉，全部',
    'Company Address Management': '地址管理',
    'Address information': '地址信息',
    'Contact Name ': '联系人姓名',
    'Please Entry Contact Name ': '请输入联系人姓名',
    'Contact Information': '联系方式',
    'Please Entry Contact Information': '请输入联系方式',
    'Country': '国家',
    'Detail Address': '详细地址',
    'Please Entry Detail Address': '请输入详细地址',
    'Address': '地址',
    'Post Code': '邮政编码',
    'Please Entry Post Code': '请输入邮政编码',
    'Receiving region': '收货地区',
    'Remarks': '备注',
    'Qualification information': '资质信息',
    'Company License Management': '资质管理',
    'Business License': '营业执照',
    'Legal Person Certificate': '法人证件',
    'Company Certificate': '公司资质',
    'Qualification materials': '资质材料',
    'Please upload Company License Management': '请上传资质管理',
    'Please upload Business License': '请上传营业执照',
    'Please upload Legal Person Certificate': '请上传法人证件',
    'Please upload Company Certificate': '请上传公司资质',
    'Upload Files': '上传文件',
    'Upload': '上传',
    'Support Extension': '支持扩展名',
    'Certification': '资质',
    'Life Cycle Management': '生命周期管理',
    'Cooperative category': '合作品类',
    'Contract Document': '合同文件',
    'You are already a supplier': '你已经是供应商',
    'Cannot be greater than 50M': '不能大于50M',
    'Admission application approval is pending, please be patient~': '入驻申请审批中，请耐心等待～',
    'The application for entry has been rejected for the following reasons:': '入驻申请审批拒绝，理由是：',
    'Back': '返回',
    'Continue to apply': '继续申请',
    'Apply': '申请',
    'reapply': '重新申请'
  }
};
